import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from '../axios'
import router from '../router'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const token = ref(localStorage.getItem('token') || null)
  
  const isAuthenticated = computed(() => !!token.value)
  
  // Initialiser axios avec le token
  if (token.value) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
  }
  
  // Charger l'utilisateur courant
  const loadUser = async () => {
    if (!token.value) return
    
    try {
      const response = await axios.get('/api/v1/users/me')
      user.value = response.data
    } catch (error) {
      console.error('Erreur lors du chargement de l\'utilisateur:', error)
      await logout()
    }
  }
  
  // Connexion
  const login = async (email, password) => {
    try {
      const response = await axios.post('/api/v1/auth/login', {
        username: email,
        password: password
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      
      const { access_token } = response.data
      token.value = access_token
      localStorage.setItem('token', access_token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
      
      await loadUser()
      return true
    } catch (error) {
      console.error('Erreur de connexion:', error)
      return false
    }
  }
  
  // Déconnexion
  const logout = async () => {
    user.value = null
    token.value = null
    localStorage.removeItem('token')
    delete axios.defaults.headers.common['Authorization']
  }
  
  // Vérifier si l'utilisateur est connecté au chargement de l'application
  if (token.value) {
    loadUser()
  }
  
  return {
    user,
    token,
    isAuthenticated,
    login,
    logout,
    loadUser
  }
})
